import React, { useEffect, useState } from "react";

const MinimalUserDisplay: React.FC = () => {
    const [userData, setUserData] = useState<any>(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const localStorageValue = localStorage.getItem("localStorage");
            if (localStorageValue) {
                try {
                    const parsedData = JSON.parse(localStorageValue);
                    const user = parsedData?.user || {};
                    console.log(user, parsedData)
                    setUserData({
                        name: user?.name,
                        agency: user?.agencyName,
                        pos: parsedData?.posList,
                        posCurrencyCode: user?.posCurrencyCode,
                        flightPass: parsedData?.flightPass,
                        session: parsedData?.session,
                        token: user?.token,
                    });
                } catch {
                    console.error("Failed to parse localStorage data as JSON.");
                }
            } else {
                setUserData(null);
            }
        }, 1000); // Check every 1 second

        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);

    return (
        <div>
            {userData ? (
                <div style={{margin: '20px'}}>
                    <h1>User Information</h1>
                    <p><strong>Name:</strong> {userData.name || "N/A"}</p>
                    <p><strong>Agency:</strong> {userData.agency || "N/A"}</p>
                    <p><strong>POS:</strong> {userData.pos?.map((item: any) => `${item.id} - ${item.currencyCode}`).join(" | ") || "N/A"}</p>
                    <p><strong>POS Currency Code:</strong> {userData.posCurrencyCode || "N/A"}</p>
                    <p><strong>Flight Pass:</strong> {userData.flightPass || "N/A"}</p>
                    <p><strong>Token:</strong> {userData.token || "N/A"}</p>
                    <p><strong>Session:</strong> {JSON.stringify(userData.session, undefined, 2)} </p>
                </div>
            ) : (
                <h1>No user data available.</h1>
            )}
        </div>
    );
};

export default MinimalUserDisplay;